import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

const Photo = ({
  fill = 'none',
  color = 'icon.primary',
  strokeWidth = 1.5,
  ...props
}) => (
  <IconBase viewBox='0 0 20 19' {...props}>
    <Path
      d={
        'M10.1935 10.2657C11.3798 11.452 11.3798 13.3754 10.1935 14.5617C9.00721 15.748 7.08384 ' +
        '15.748 5.89754 14.5617C4.71124 13.3754 4.71124 11.452 5.89754 10.2657C7.08384 9.0794 ' +
        '9.00721 9.0794 10.1935 10.2657'
      }
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill={fill}
    />
    <Path
      d={
        'M14.8559 9.38179V16.6199C14.8559 17.4618 14.174 18.1437 13.3321 18.1437H2.66541C1.82351 ' +
        '18.1437 1.1416 17.4618 1.1416 16.6199V9.38179C1.1416 8.53988 1.82351 7.85798 2.66541 ' +
        '7.85798H4.18922L5.30313 5.95017C5.43951 5.71627 5.69017 5.57227 5.96141 5.57227H10.0026C10.27 ' +
        '5.57227 10.5176 5.71246 10.6555 5.94103L11.8083 ' +
        '7.85798H13.3321C14.174 7.85798 14.8559 8.53988 14.8559 9.38179Z'
      }
      fillRule='evenodd'
      clipRule='evenodd'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill={fill}
    />
    <Path
      d='M19 3.50218H14'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill={fill}
    />
    <Path
      d='M16.5012 1V6'
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill={fill}
    />
  </IconBase>
)

Photo.propTypes = {
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
  fill: PropTypes.string,
}

export default Photo
